module.exports = __webpack_public_path__ + "static/media/portfolio.2d27e395.png";